import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_PRODUCT_QUERY_KEY } from './useGetProduct';

import ProductsService, { RerunProductDto } from '@/services/ProductsService';

export function useRerunProduct(catalogId: number) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (rerunProductDto: RerunProductDto) =>
      ProductsService.rerunProduct(rerunProductDto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_PRODUCT_QUERY_KEY(catalogId),
      });
    },
  });

  return {
    rerunProduct: mutateAsync,
    isLoading: isPending,
  };
}
